export var OKTA_NOT_FOUND = "E0000007";